import { createSelector } from 'reselect';

const getCommonState = (state) => state.common || {};

export const getToastMessage = createSelector(
    getCommonState,
    (common) => common.toastMessage,
);
export const getToastType = createSelector(
    getCommonState,
    (common) => common.toastType,
);
export const getToastAutoHideDuration = createSelector(
    getCommonState,
    (common) => common.toastAutoHideDuration,
);
export const getToastAnchorOrigin = createSelector(
    getCommonState,
    (common) => common.toastAnchorOrigin,
);
export const getShowToast = createSelector(
    getCommonState,
    (common) => common.showToast,
);
